import { connect } from "react-redux"
import React, { Component } from "react"
import { createAction } from "redux-actions"
import { browserHistory, Link } from "react-router"
import Logo from "../../assets/newblacklogo.png"

import {
  login,
  signup,
  check,
  EDIT_USER,
  CLEAR_VIDEOS,
  fbConnect
} from "../../actions"
import "./signin.css"
import debounce from 'lodash/debounce'

const mapStateToProps = (state, ownProps) => {
  const { me } = state
  return {
    me,
    redirect: ownProps.viewParams.query.redirect,
    action: ownProps.action,
  }
}

class SignIn extends Component {
  constructor() {
    super()
    this.validate = this.validate.bind(this)
    this.validateDebounced = debounce(this.validate, 500, { leading: true, trailing: true })
  }

  componentWillMount() {
    const { dispatch } = this.props
    this.props.dispatch(createAction(EDIT_USER)({ userExists: null }))
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.action !== this.props.action) {
      this.props.dispatch(createAction(EDIT_USER)({ userExists: null }))
    }
  }

  compononentWillUnmount() {
    this.unmounted = true
  }
  
  validate(e) {
    if (this.unmounted || !this.username || !this.password) {
      return
    }
    this.props.dispatch(check(this.username.value, this.password.value))
  }

  render() {
    const done = ({ error, pro }) => {
      if (error) {
        console.log(error)
        return
      }

      const redirectUrl = this.props.redirect
          ? decodeURIComponent(this.props.redirect)
          : "/"
          
      window.location = redirectUrl
    }
    const { dispatch, me, action } = this.props
    return (
      <div className="container signin">
        <div className="row">
          <div className="signin-box col flex-middle">
            <a href="/">
              <img className="logo" src={Logo} role="presentation" />
            </a>
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to={`/signup${typeof window !== "undefined" ? window.location.search : ""}`}
                  activeClassName="active"
                >
                  Sign Up
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to={`/login${typeof window !== "undefined" ? window.location.search : ""}`}
                  activeClassName="active"
                >
                  Log In
                </Link>
              </li>
            </ul>
            <div className="card">
              <button className="btn facebook-button" onClick={() => {
                console.log("Facebook button clicked")
                  window.FB.login((response) => {
                    let authResponse = window.FB.getAuthResponse()
                    const authToken = authResponse.accessToken
                    window.FB.api('/me', { locale: 'en_US', fields: 'name, email' },
                      function(response) {
                        dispatch(
                          fbConnect(
                            authToken,
                            response.email
                          )
                        ).then(done)
                      }
                    );
                  }, {scope: "email"})
                }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 216 216" className="_5h0m" color="#ffffff">
                <path fill="#ffffff" d="M204.1 0H11.9C5.3 0 0 5.3 0 11.9v192.2c0 6.6 5.3 11.9 11.9
                11.9h103.5v-83.6H87.2V99.8h28.1v-24c0-27.9 17-43.1 41.9-43.1
                11.9 0 22.2.9 25.2 1.3v29.2h-17.3c-13.5 0-16.2 6.4-16.2
                15.9v20.8h32.3l-4.2 32.6h-28V216h55c6.6 0 11.9-5.3
                11.9-11.9V11.9C216 5.3 210.7 0 204.1 0z"></path>
                </svg>
                <span className="facebook-text">Continue with Facebook</span>
              </button>
              <div className="separator"><span>or</span></div>
              <form
                onSubmit={e => {
                  e.preventDefault()
                  dispatch(createAction(CLEAR_VIDEOS)())
                  if (action === "signup") {
                    dispatch(
                      signup(
                        this.username.value,
                        this.password.value,
                        this.username.value
                      )
                    ).then(done)
                  } else {
                    dispatch(
                      login(this.username.value, this.password.value)
                    ).then(done)
                  }
                }}
              >
                <div className="form-group">
                  <input
                    type="username"
                    className="form-control"
                    placeholder={
                      action === "signup"
                        ? "Email address"
                        : "Email or username"
                    }
                    onChange={this.validateDebounced}
                    ref={node => {
                      this.username = node
                    }}
                  />
                  {action === "signup"
                    ? !this.username || !this.username.value.length
                        ? <span />
                        : this.username && this.username.value.length < 4
                            ? <span className="form-control-emoji">😞</span>
                            : me.userExists !== null && !me.userExists
                                ? <span className="form-control-emoji">😊</span>
                                : me.userExists
                                    ? <span className="form-control-emoji">
                                        😞
                                      </span>
                                    : ""
                    : me.userExists
                        ? <span className="form-control-emoji">😊</span>
                        : me.userExists !== null && !me.userExists
                            ? <span className="form-control-emoji">😞</span>
                            : ""}
                </div>
                <div className="form-group">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Password"
                    onChange={this.validateDebounced}
                    ref={node => {
                      this.password = node
                    }}
                  />
                  {me.error === "AuthError" && action === "login"
                    ? <span className="form-control-emoji">😞</span>
                    : ""}
                  {this.password &&
                    this.password.value.length &&
                    this.password.value.length < 6 &&
                    action === "signup"
                    ? <span className="form-control-emoji">😞</span>
                    : ""}
                  {this.password &&
                    this.password.value.length &&
                    this.password.value.length >= 6 &&
                    action === "signup"
                    ? <span className="form-control-emoji">😊</span>
                    : ""}
                </div>
                {me.message != null
                  ? <div
                      className={`${me.error ? "error" : "info"} signin-alert`}
                    >
                      {me.message}
                    </div>
                  : ""}
                {action !== "signup"
                  ? <Link
                      to="/recover"
                      className="forgot-password float-left"
                    >
                      Recover account
                    </Link>
                  : ""}
                <button
                  type="submit"
                  className={`blue-button float-right ${me.loggingIn ? 'disabled': ''}`}
                  disabled={me.loggingIn}
                >
                  {action === "login" ? "Log In" : "Sign Up"}
                </button>
                <div style={{ clear: "both" }} />
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(SignIn)
